// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RecoveryKeyModal Component Styles
 */

.recovery-key-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 10000;
  animation: modalFadeIn 0.2s ease;
}

.recovery-key-modal-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease;
}

.recovery-key-modal-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e5e5;
}

.recovery-key-modal-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #222;
}

.recovery-key-modal-content {
  padding: 24px;
}

.recovery-key-modal-description {
  margin-bottom: 24px;
}

.recovery-key-modal-description p {
  margin: 0 0 16px;
  color: #555;
  line-height: 1.6;
}

.recovery-key-example {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px 16px;
  margin-top: 12px;
}

.recovery-key-example-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.recovery-key-example-code {
  display: block;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 13px;
  color: #333;
  word-break: break-all;
  letter-spacing: 0.5px;
}

.recovery-key-form {
  margin-top: 24px;
}

.recovery-key-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  color: #c00;
  font-size: 14px;
  animation: shake 0.3s ease;
}

.recovery-key-error ion-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.recovery-key-warning {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  color: #856404;
  font-size: 14px;
  text-align: center;
}

.recovery-key-cooldown {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 6px;
  color: #495057;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}

.recovery-key-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.recovery-key-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  width: 100%;
}

.recovery-key-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.recovery-key-btn-primary {
  background-color: #007bff;
  color: white;
}

.recovery-key-btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.recovery-key-btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.recovery-key-btn-secondary {
  background-color: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
}

.recovery-key-btn-secondary:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.recovery-key-btn-danger {
  background-color: #fff;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.recovery-key-btn-danger:hover:not(:disabled) {
  background-color: #dc3545;
  color: white;
}

.recovery-key-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.recovery-key-modal-footer {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e5e5;
  text-align: center;
}

.recovery-key-help-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}

.recovery-key-help-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.recovery-key-help-link ion-icon {
  font-size: 18px;
}

/* Animations */
@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-2px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(2px);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .recovery-key-modal-container {
    background: #1a1a1a;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  }

  .recovery-key-modal-header {
    border-bottom-color: #333;
  }

  .recovery-key-modal-title {
    color: #e0e0e0;
  }

  .recovery-key-modal-description p {
    color: #aaa;
  }

  .recovery-key-example {
    background-color: #0d0d0d;
    border-color: #333;
  }

  .recovery-key-example-label {
    color: #999;
  }

  .recovery-key-example-code {
    color: #ccc;
  }

  .recovery-key-error {
    background-color: #2a0000;
    border-color: #4a0000;
    color: #ff6b6b;
  }

  .recovery-key-warning {
    background-color: #2a2000;
    border-color: #4a4000;
    color: #ffa500;
  }

  .recovery-key-cooldown {
    background-color: #0d0d0d;
    border-color: #333;
    color: #999;
  }

  .recovery-key-btn-primary {
    background-color: #0d6efd;
  }

  .recovery-key-btn-primary:hover:not(:disabled) {
    background-color: #0b5ed7;
  }

  .recovery-key-btn-secondary {
    background-color: #2a2a2a;
    color: #ccc;
    border-color: #444;
  }

  .recovery-key-btn-secondary:hover:not(:disabled) {
    background-color: #333;
    border-color: #555;
  }

  .recovery-key-btn-danger {
    background-color: #1a1a1a;
    color: #ff6b6b;
    border-color: #ff6b6b;
  }

  .recovery-key-btn-danger:hover:not(:disabled) {
    background-color: #dc3545;
    color: white;
  }

  .recovery-key-modal-footer {
    border-top-color: #333;
  }

  .recovery-key-help-link {
    color: #6cb3ff;
  }

  .recovery-key-help-link:hover {
    color: #4a9fff;
  }
}

/* Mobile responsiveness */
@media (max-width: 640px) {
  .recovery-key-modal-overlay {
    padding: 0;
  }

  .recovery-key-modal-container {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    border-radius: 0;
  }

  .recovery-key-modal-header {
    padding: 20px;
  }

  .recovery-key-modal-title {
    font-size: 20px;
  }

  .recovery-key-modal-content {
    padding: 20px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .recovery-key-modal-overlay,
  .recovery-key-modal-container,
  .recovery-key-error {
    animation: none;
  }

  .recovery-key-btn {
    transition: none;
  }

  .recovery-key-spinner {
    animation: spin 1.5s linear infinite;
  }
}

/* High contrast */
@media (prefers-contrast: high) {
  .recovery-key-modal-container {
    border: 2px solid currentColor;
  }

  .recovery-key-btn {
    border: 2px solid currentColor;
  }

  .recovery-key-error,
  .recovery-key-warning,
  .recovery-key-cooldown {
    border-width: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Recovery/RecoveryKeyModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * RecoveryKeyModal Component Styles\n */\n\n.recovery-key-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 10000;\n  animation: modalFadeIn 0.2s ease;\n}\n\n.recovery-key-modal-container {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s ease;\n}\n\n.recovery-key-modal-header {\n  padding: 24px 24px 16px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.recovery-key-modal-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #222;\n}\n\n.recovery-key-modal-content {\n  padding: 24px;\n}\n\n.recovery-key-modal-description {\n  margin-bottom: 24px;\n}\n\n.recovery-key-modal-description p {\n  margin: 0 0 16px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.recovery-key-example {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-top: 12px;\n}\n\n.recovery-key-example-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.recovery-key-example-code {\n  display: block;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 13px;\n  color: #333;\n  word-break: break-all;\n  letter-spacing: 0.5px;\n}\n\n.recovery-key-form {\n  margin-top: 24px;\n}\n\n.recovery-key-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  color: #c00;\n  font-size: 14px;\n  animation: shake 0.3s ease;\n}\n\n.recovery-key-error ion-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.recovery-key-warning {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  color: #856404;\n  font-size: 14px;\n  text-align: center;\n}\n\n.recovery-key-cooldown {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  color: #495057;\n  font-size: 14px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.recovery-key-modal-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.recovery-key-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 48px;\n  width: 100%;\n}\n\n.recovery-key-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.recovery-key-btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.recovery-key-btn-primary:hover:not(:disabled) {\n  background-color: #0056b3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);\n}\n\n.recovery-key-btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.recovery-key-btn-secondary {\n  background-color: #f8f9fa;\n  color: #495057;\n  border: 1px solid #dee2e6;\n}\n\n.recovery-key-btn-secondary:hover:not(:disabled) {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.recovery-key-btn-danger {\n  background-color: #fff;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n}\n\n.recovery-key-btn-danger:hover:not(:disabled) {\n  background-color: #dc3545;\n  color: white;\n}\n\n.recovery-key-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n.recovery-key-modal-footer {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #e5e5e5;\n  text-align: center;\n}\n\n.recovery-key-help-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #007bff;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.2s ease;\n}\n\n.recovery-key-help-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.recovery-key-help-link ion-icon {\n  font-size: 18px;\n}\n\n/* Animations */\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateX(-2px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateX(2px);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .recovery-key-modal-container {\n    background: #1a1a1a;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\n  }\n\n  .recovery-key-modal-header {\n    border-bottom-color: #333;\n  }\n\n  .recovery-key-modal-title {\n    color: #e0e0e0;\n  }\n\n  .recovery-key-modal-description p {\n    color: #aaa;\n  }\n\n  .recovery-key-example {\n    background-color: #0d0d0d;\n    border-color: #333;\n  }\n\n  .recovery-key-example-label {\n    color: #999;\n  }\n\n  .recovery-key-example-code {\n    color: #ccc;\n  }\n\n  .recovery-key-error {\n    background-color: #2a0000;\n    border-color: #4a0000;\n    color: #ff6b6b;\n  }\n\n  .recovery-key-warning {\n    background-color: #2a2000;\n    border-color: #4a4000;\n    color: #ffa500;\n  }\n\n  .recovery-key-cooldown {\n    background-color: #0d0d0d;\n    border-color: #333;\n    color: #999;\n  }\n\n  .recovery-key-btn-primary {\n    background-color: #0d6efd;\n  }\n\n  .recovery-key-btn-primary:hover:not(:disabled) {\n    background-color: #0b5ed7;\n  }\n\n  .recovery-key-btn-secondary {\n    background-color: #2a2a2a;\n    color: #ccc;\n    border-color: #444;\n  }\n\n  .recovery-key-btn-secondary:hover:not(:disabled) {\n    background-color: #333;\n    border-color: #555;\n  }\n\n  .recovery-key-btn-danger {\n    background-color: #1a1a1a;\n    color: #ff6b6b;\n    border-color: #ff6b6b;\n  }\n\n  .recovery-key-btn-danger:hover:not(:disabled) {\n    background-color: #dc3545;\n    color: white;\n  }\n\n  .recovery-key-modal-footer {\n    border-top-color: #333;\n  }\n\n  .recovery-key-help-link {\n    color: #6cb3ff;\n  }\n\n  .recovery-key-help-link:hover {\n    color: #4a9fff;\n  }\n}\n\n/* Mobile responsiveness */\n@media (max-width: 640px) {\n  .recovery-key-modal-overlay {\n    padding: 0;\n  }\n\n  .recovery-key-modal-container {\n    max-width: 100%;\n    max-height: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n\n  .recovery-key-modal-header {\n    padding: 20px;\n  }\n\n  .recovery-key-modal-title {\n    font-size: 20px;\n  }\n\n  .recovery-key-modal-content {\n    padding: 20px;\n  }\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .recovery-key-modal-overlay,\n  .recovery-key-modal-container,\n  .recovery-key-error {\n    animation: none;\n  }\n\n  .recovery-key-btn {\n    transition: none;\n  }\n\n  .recovery-key-spinner {\n    animation: spin 1.5s linear infinite;\n  }\n}\n\n/* High contrast */\n@media (prefers-contrast: high) {\n  .recovery-key-modal-container {\n    border: 2px solid currentColor;\n  }\n\n  .recovery-key-btn {\n    border: 2px solid currentColor;\n  }\n\n  .recovery-key-error,\n  .recovery-key-warning,\n  .recovery-key-cooldown {\n    border-width: 2px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
